import { Suspense, useEffect } from "react";
import { Routes, Route, useLocation, Navigate, matchPath} from "react-router-dom";
import { Skeleton } from "antd";

import ProtectedLayout from "./components/layouts/ProtectedLayout";
import PublicLayout from "./components/layouts/PublicLayout";
import AuthProvider from "./providers/AuthProvider";
import { publicRoutes, protectedRoutes } from "./routes";
import { useSelector, useDispatch } from "react-redux";
import { setPermissions } from "./redux/slices/authSlice"; 
import NotFound from "./pages/auth/NotFound";

const ProtectedRoute = ({ children }) => {
  const { accessToken, accessRoutes, permissions, } = useSelector((state) => state.auth);
  const dispatch = useDispatch()
  const location = useLocation();

  const matchedRoute = accessRoutes.find((route) =>
    matchPath({ path: route, exact: true, strict: false }, location.pathname)
  );

  useEffect(() => {
    dispatch(setPermissions(matchedRoute?.permitted_actions || []))
  }, [location.pathname]); 
  
  if (!accessToken) return <Navigate to="/login" replace />;
  if (!matchedRoute) return <Navigate to="/403" replace />;

  return children;
};
const Router = () => {
  return (
    <AuthProvider>
      <Routes>
        {/** Public Routes **/}
        <Route element={<PublicLayout />}>
          {publicRoutes.map((route, i) => {
            return (
              <Route
                key={`public-${i}`}
                path={route.path}
                element={
                  <Suspense fallback={<Skeleton />}>
                    <route.element />
                  </Suspense>
                }
              />
            );
          })}
        </Route>

        {/** Protected Routes **/}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <ProtectedLayout />
            </ProtectedRoute>
          }
        >
          {protectedRoutes.map((route, i) => {
            return (
              <Route
                key={`protected-${i}`}
                path={route.path}
                element={
                  <Suspense
                    fallback={
                      <Skeleton
                        active
                        style={{ margin: "10px 80px", width: "90%" }}
                      />
                    }
                  >
                    <route.element />
                  </Suspense>
                }
              />
            );
          })}
        </Route>
          {/** 404 Page (Wildcard Route) **/}
          <Route path="*" element={<NotFound />} />
      </Routes>
    </AuthProvider>
  );
};

export default Router;
